import * as Popover from "@radix-ui/react-popover";
import { trackLanguageChange, trackHeaderClick } from "../lib/analytics";
import { useLanguage } from "../contexts/LanguageContext";
import type { Language } from "../types";

export function LanguageSwitcher() {
  const { language, setLanguage } = useLanguage();

  const languages: { code: Language; label: string; flag: string }[] = [
    { code: "en", label: "English", flag: "🇬🇧" },
    { code: "fr", label: "Français", flag: "🇫🇷" },
    { code: "ar", label: "العربية", flag: "🇸🇦" },
  ];

  const currentLanguage = languages.find((lang) => lang.code === language);

  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <button
          onClick={() => trackHeaderClick('language_switcher')}
          className="h-9 w-9 flex items-center justify-center hover:bg-slate-100 rounded-xl transition-smooth"
          aria-label="Select language"
        >
          <span className="text-2xl">{currentLanguage?.flag}</span>
        </button>
      </Popover.Trigger>

      <Popover.Portal>
        <Popover.Content
          className="bg-white rounded-2xl shadow-xl border border-slate-200 p-1 min-w-[170px] z-50 animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 overflow-hidden"
          sideOffset={8}
          align="end"
          collisionPadding={10}
        >
          {languages.map((lang, index) => (
            <button
              key={lang.code}
              onClick={() => {
                trackLanguageChange(lang.code);
                setLanguage(lang.code);
              }}
              className={`
                w-full h-[44px] px-4 flex items-center gap-3 hover:bg-slate-50 transition-smooth
                ${
                  language === lang.code
                    ? "bg-gradient-to-r from-primary-lighter to-primary-light"
                    : ""
                }
                ${index === 0 ? "rounded-t-[15px]" : ""}
                ${index === languages.length - 1 ? "rounded-b-[15px]" : ""}
              `}
            >
              <span className="text-2xl flex-shrink-0">{lang.flag}</span>
              <span
                className={`text-sm font-semibold flex-1 text-left ${
                  language === lang.code ? "text-primary" : "text-slate-600"
                }`}
              >
                {lang.label}
              </span>
              {language === lang.code && (
                <span className="text-primary text-base flex-shrink-0">✓</span>
              )}
            </button>
          ))}
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
